export const ORDER_STATUS_ROUTE_PATH = 'order-status';
export const ORDER_STATUS_NOTIFICATION_ACTION_KEY = 'action';
export const ORDER_STATUS_NOTIFICATION_ACTION_NAME = 'order_status';
export const ORDER_STATUS_NOTIFICATION_ID_KEY = 'order_id';
